import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersFilters } from '@ml/orders/types/orders-filters';
import { FormControl } from '@angular/forms';
import { OrderStatus } from '@ml/orders/types/order';

@Component({
  selector: 'ml-orders-filters',
  template: `
    <div fxLayout="row" fxLayoutGap="8px">
      <ml-select
        [options]="statuses"
        [control]="statusControl"
        [label]="'status'"
        [translate]="true"
        [multiple]="true"
        (select)="onSelectStatus($event)"
      ></ml-select>
    </div>
  `,
  styleUrls: ['./orders-filters.component.scss']
})
export class OrdersFiltersComponent implements OnInit {
  @Input() filters: OrdersFilters;
  @Input() customStatuses: { id: string; name: string }[];
  @Input('connection') set _connection(connection: boolean) {
    if (!connection) {
      this.statusControl.disable();
    } else {
      this.statusControl.enable();
    }
  }

  @Output() filter = new EventEmitter<OrdersFilters>();

  statusControl = new FormControl();
  statuses = Object.values(OrderStatus).map((status: string) => ({
    id: status,
    name: status
  }));

  constructor() {}

  ngOnInit() {
    if (this.customStatuses) {
      this.statuses = this.customStatuses;
    }

    this.statusControl.setValue(this.filters.status);
  }

  onSelectStatus(statuses: string[]) {
    const filters = new OrdersFilters(statuses);
    this.filter.emit(filters);
  }
}
